import React from 'react'
import className from 'classnames'

export const Hero = (props) => {

  return <div className={className(`generic-hero`, props.className)} style={{backgroundImage: `url(${props.imageUrl})`}}>
    <h1 className='font-desktop-xxl'>{props.title}</h1>
  </div>
}
